export default "__VITE_ASSET__CCI9HzY___"